import { HttpMethod } from '../../http-method'

export const postVehicleLessor = (VehicleUUID: string, LeaseCompanyUserUUID?: string) => ({
  method: HttpMethod.POST,
  url: '/modules/accounts/create-for-vehicle-lessor',
  data: { VehicleUUID, LeaseCompanyUserUUID }
})

export const updateAccountForLeaseFlow = (params: { registration: string; leaseCompanyUserID?: string }) => ({
  method: HttpMethod.PUT,
  url: `/accounts/for-lease-flow`,
  params
})

export const sendOpenInvoicesStatement = (accountUUID: string, data: { InvoiceUUIDs: string[] }) => ({
  method: HttpMethod.POST,
  url: `/modules/accounts/${accountUUID}/send-open-invoices-statement`,
  data
})
